import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import FileRow from './FileRow';
import SortArrows from '../filters/SortArrows';
import './file-tables.css';

const FileTable = ({ files, sortOrder, sort, order, onSortClick, handleFileClick }) => {
	const tableClass = cs("file-table", {"file-table--sortable": sortOrder});
	return (
		<div className={tableClass}>
			<div className="file-table__header">
				<span className="file-table__row-title file-table__col-head">
					{sortOrder && <span className="file-table__row-name" onClick={() => onSortClick("file")}>File Name</span>}
					{!sortOrder && <span className="file-table__row-name">File Name</span>}
					{sortOrder && <SortArrows name="file" sort={sort} order={order} />}
				</span>
				<span className="file-table__row-date file-table__col-head">
					{sortOrder && <span className="file-table__row-name" onClick={() => onSortClick("date")}>Date Added</span>}
					{!sortOrder && <span className="file-table__row-name">Date Added</span>}
					{sortOrder && <SortArrows name="date" sort={sort} order={order} />}
				</span>
				<span className="file-table__row-links">&nbsp;</span>
			</div>
			<div className="file-table__body">
				{
					files.map(file => {
						return <FileRow key={file.id} file={file} handleFileClick={handleFileClick} />
					})
				}
			</div>
		</div>
	);
};

FileTable.propTypes = {
	files: PropTypes.arrayOf(
		PropTypes.object.isRequired,
	).isRequired,
	sortOrder: PropTypes.bool.isRequired,
	sort: PropTypes.string,
	order: PropTypes.bool,
	onSortClick: PropTypes.func,
	handleFileClick: PropTypes.func.isRequired,
}

FileTable.defaultProps = {
	sortOrder: true
}

export default FileTable;


// WEBPACK FOOTER //
// ./src/components/common/files/FileTable/index.js